import { createSelector } from "reselect";
import { RootState } from "../../state";

export const companySelector = createSelector(
  (state: RootState) => state.companies.common.companyId,
  (state: RootState) => state.companies.entities.companies,
  (companyId, companies) => (companyId ? companies[companyId] : undefined)
);

export const companyMembershipSectionsSelector = createSelector(
  (state: RootState) => state.companies.show.companyMembershipSectionIds,
  (state: RootState) => state.companies.entities.company_membership_sections,
  (ids, sections) => ids.map(id => sections[id]!)
);

export const sectionsSelector = createSelector(
  (state: RootState) => state.companies.members.sectionIds,
  (state: RootState) => state.companies.entities.company_membership_sections,
  (ids, sections) => ids.map(id => sections[id]!)
);

export const membershipsSelector = createSelector(
  (state: RootState) => state.companies.members.membershipIds,
  (state: RootState) => state.companies.entities.company_memberships,
  (ids, memberships) => ids.map(id => memberships[id]!)
);

export const companyMembersSelector = createSelector(
  (state: RootState) => state.companies.members.membershipIds,
  (state: RootState) => state.companies.entities.company_memberships,
  (state: RootState) => state.companies.entities.users,
  (ids, memberships, users) => ids.map(id => users[memberships[id]!.user]!)
);

export const featuredPostsSelector = createSelector(
  (state: RootState) => state.companies.posts.featuredPostIds,
  (state: RootState) => state.companies.entities.posts,
  (ids, posts) => ids.map(id => posts[id]!)
);

export const postsSelector = createSelector(
  (state: RootState) => state.companies.posts.postIds,
  (state: RootState) => state.companies.entities.posts,
  (ids, posts) => ids.map(id => posts[id]!)
);

export const pinnablePostsSelector = createSelector(
  (state: RootState) => state.companies.posts.pinnablePostIds,
  (state: RootState) => state.companies.entities.posts,
  (ids, posts) => ids.map(id => posts[id]!)
);

export const spacesSelector = createSelector(
  (state: RootState) => state.companies.posts.spaceIds,
  (state: RootState) => state.companies.entities.post_spaces,
  (ids, spaces) => ids.map(id => spaces[id]!)
);

export const featuredProjectsSelector = createSelector(
  (state: RootState) => state.companies.show.projectIds,
  (state: RootState) => state.companies.entities.projects,
  (ids, projects) => ids.map(id => projects[id]!)
);

export const projectsSelector = createSelector(
  (state: RootState) => state.companies.projects.projectIds,
  (state: RootState) => state.companies.entities.projects,
  (ids, projects) => ids.map(id => projects[id]!)
);

export const portfolioProjectsSelector = createSelector(
  (state: RootState) => state.companies.show.portfolioProjectIds,
  (state: RootState) => state.companies.entities.portfolio_projects,
  (ids, projects) => ids.map(id => projects[id]!)
);

export const similarCompaniesSelector = createSelector(
  (state: RootState) => state.companies.show.similarCompanyIds,
  (state: RootState) => state.companies.entities.companies,
  (ids, companies) => ids.map(id => companies[id]!).slice(0, 5)
);

export const visibleCompanyValuesSelecor = createSelector(
  (state: RootState) => state.companies.show.draftCompanyValues,
  values => values.filter(val => val.rank >= 0).sort((a, b) => a.rank - b.rank)
);

export const isDirtySelector = createSelector(
  (state: RootState) => state.companies,
  companies =>
    companies.common.isDraftCompanyDirty ||
    companies.show.isDraftCompanyValuesDirty ||
    companies.members.isDraftMembershipsDirty ||
    companies.posts.isDraftPostPinsDirty
);

export const editableSelector = createSelector(
  (state: RootState) => state.auth.currentCompany,
  (state: RootState) => state.companies.common.companyId,
  (currentCompany, companyId) => {
    return currentCompany ? currentCompany.id === parseInt(companyId, 10) : false;
  }
);

export const isMemberSelector = createSelector(
  (state: RootState) => state.companies.common.companyId,
  (state: RootState) => state.auth.currentUser,
  (companyId, currentUser) => (currentUser ? currentUser.working_company_ids.includes(parseInt(companyId, 10)) : false)
);



// WEBPACK FOOTER //
// ./frontend/src/companies/selectors/index.ts